/** ProductRegistryRoute — skin-aware switcher for /product-registry. */
import { useUISkin } from "@/data/UISkinContext";
import ProductRegistry from "./ProductRegistry";
import ProductRegistryCockpit from "./ProductRegistryCockpit";

export default function ProductRegistryRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ProductRegistryCockpit />;
  return <ProductRegistry />;
}
